module.exports = __webpack_public_path__ + "img/ssparisi.ab1399fd.png";